const ZReportDetail = () => {
    return (
        <section className='content_container'>
            <h1>Hello World!</h1>
        </section>
    )
}

export default ZReportDetail;